import React from 'react';
import { Divider, Typography } from 'antd';
import '../../../Styles/ResearchLabs.css';
import investigatorImage from '../../../Assets/ResearchLabs/SARL/Director/SARL-Lab-Director.jpg';

const { Link, Text, Title } = Typography;

const SarlHead = () => (
  <section className="sarl-director-section">
    <div className="sarl-director-inner">
      <Title level={2} className="sarl-director-title">
        Principal Investigator/Lab Director
      </Title>
      <Divider className="ncgsa-divider" />

      <img
        className="sarl-director-photo"
        src={investigatorImage}
        alt="Dr. Imran Ali Khan"
      />

      <div className="sarl-director-details">
        <Title level={3}>Dr. Imran Ali Khan</Title>
        <Text strong>IST, Islamabad</Text>
        <Link href="mailto:imran.khan@ist.edu.pk">imran.khan@ist.edu.pk</Link>
        <Text>Phone: 051-9675642</Text>
      </div>
    </div>
  </section>
);

export default SarlHead;
